import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { Component } from 'react';
import { U as UIDContext } from './UIDContext-DaboSTJ1.js';
import { v as validateUidCharSafe } from './validateUidCharSafe-fddCu4jj.js';

/*
  Memoizing createUid prevents redundant calls up the react tree.
 */
function createMemoizedUid() {
  let lastParentPrefixer;
  let lastValue;
  let lastUid;
  return function createUid(parentPrefixer, value) {
    if (lastUid === undefined || parentPrefixer !== lastParentPrefixer || value !== lastValue) {
      lastParentPrefixer = parentPrefixer;
      lastValue = value;
      lastUid = parentPrefixer(value);
    }
    return lastUid;
  };
}
class UIDConsumer extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "uid", createMemoizedUid());
  }
  render() {
    const {
      children,
      value
    } = this.props;
    const validatedValue = validateUidCharSafe(value, 'UIDConsumer');
    return /*#__PURE__*/React__default.createElement(UIDContext.Consumer, null, prefixer => children(this.uid(prefixer, validatedValue)));
  }
}

export { UIDConsumer as U };
//# sourceMappingURL=UIDConsumer-vNSO4p4V.js.map
